'use client';

import { useMemo } from 'react';
import { ListingReview } from '@/utils/platform-api/__generated__/graphql';

export enum ReviewSortKey {
  'Most recent' = 'newest',
  'Highest rated' = 'highest',
  'Lowest rated' = 'lowest',
}

export const DefaultReviewSortKey = ReviewSortKey['Most recent'];

export const useReviewSort = (reviews: ListingReview[], sort: string) =>
  useMemo(() => {
    switch (sort) {
      case ReviewSortKey['Most recent']:
        return reviews.sort(
          (a, b) =>
            new Date(b.submitted_date).getTime() -
            new Date(a.submitted_date).getTime()
        );
      case ReviewSortKey['Highest rated']:
        return reviews.sort((a, b) => b.rating - a.rating);
      case ReviewSortKey['Lowest rated']:
        return reviews.sort((a, b) => a.rating - b.rating);
      default:
        return reviews;
    }
  }, [reviews, sort]);
